module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/738a69d73a36644e21fc17a00b1bf3c8.png";